export enum UserPlatformType {
	Sourcing = 1,
	Vendor = 2,
	Customer = 3,
	AccountManagement = 4,
	ContractManagement = 5,
	SME = 6,
	CustomerNonAuthenticated = 7,
	CustomerBoardNonAuthenticated = 8
}

export enum UserNamedPlatformType {
	Vendor = 'Vendor',
	Customer = 'Customer',
	Contract = 'Contract'
}
